import { db } from "./config";
import { ref, set, get, update, onValue, off } from "firebase/database";

// ── CREATE A NEW ROOM ─────────────────────────────────────────────
export const createRoom = async (roomCode, playerName) => {
  const roomRef = ref(db, `rooms/${roomCode}`);
  const roomData = {
    round: 1,
    status: "waiting", // waiting | playing | finished
    createdAt: Date.now(),
    p1: {
      name: playerName,
      choice: null,
      score: 0,
    },
    p2: {
      name: null,
      choice: null,
      score: 0,
    },
  };
  await set(roomRef, roomData);
  return roomData;
};

// ── JOIN AN EXISTING ROOM ─────────────────────────────────────────
export const joinRoom = async (roomCode, playerName) => {
  const roomRef = ref(db, `rooms/${roomCode}`);
  const snapshot = await get(roomRef);

  if (!snapshot.exists()) throw new Error("Room not found!");
  const data = snapshot.val();
  if (data.p2.name) throw new Error("Room is full!");
  if (data.status === "finished") throw new Error("Game already ended!");

  await update(roomRef, {
    "p2/name": playerName,
    status: "playing",
  });

  return { ...data, p2: { ...data.p2, name: playerName }, status: "playing" };
};

// ── MAKE A CHOICE ─────────────────────────────────────────────────
export const makeChoice = async (roomCode, slot, choice) => {
  // slot = "p1" or "p2"
  await update(ref(db, `rooms/${roomCode}`), {
    [`${slot}/choice`]: choice,
  });
};

// ── ADVANCE TO NEXT ROUND (called by host/p1) ─────────────────────
export const nextRound = async (roomCode, currentData) => {
  const { p1, p2, round } = currentData;

  // Calculate new scores
  let p1Score = p1.score;
  let p2Score = p2.score;
  const result = getWinner(p1.choice, p2.choice);
  if (result === "p1") p1Score += 1;
  if (result === "p2") p2Score += 1;

  await set(ref(db, `rooms/${roomCode}`), {
    ...currentData,
    round: round + 1,
    status: "playing",
    p1: { ...p1, choice: null, score: p1Score },
    p2: { ...p2, choice: null, score: p2Score },
  });
};

// ── LISTEN TO ROOM CHANGES IN REALTIME ───────────────────────────
export const listenToRoom = (roomCode, callback) => {
  const roomRef = ref(db, `rooms/${roomCode}`);
  onValue(roomRef, (snapshot) => {
    if (snapshot.exists()) {
      callback(snapshot.val());
    }
  });
  // Return unsubscribe function
  return () => off(roomRef);
};

// ── HELPER: determine winner from choices ─────────────────────────
export const getWinner = (p1Choice, p2Choice) => {
  if (!p1Choice || !p2Choice) return null;
  if (p1Choice === p2Choice) return "draw";
  const wins = { rock: "scissors", paper: "rock", scissors: "paper" };
  return wins[p1Choice] === p2Choice ? "p1" : "p2";
};